import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ForgotPasswordComponentService } from "@spartacus/user/profile/components";
import { UntypedFormGroup } from "@angular/forms";
import { Location } from '@angular/common';

@Component({
  selector: 'cx-forgot-password',
  templateUrl: './custom-forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomForgotPasswordComponent {
  constructor(protected service: ForgotPasswordComponentService,
              private _location: Location,
  ) {}

  form: UntypedFormGroup = this.service.form;
  isUpdating$ = this.service.isUpdating$;

  onSubmit(): void {
    this.service.requestEmail();
  }

  back() {
    this._location.back();
  }

}
